/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { Fragment, useState } from 'react';
import { Labeled } from 'react-admin';

import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import PreviewDialog from './PreviewDialogAdd';

const AttachPreviewsButton = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDialog = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const onValidated = (preview) => {
    preview.id = undefined;
    props.onPreviewAdded(preview);
  };

  return (
    <Fragment>
      <Labeled label="Attach a preview or update the thumbnail of the asset. It will be saved automatically.">
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={openDialog}
        >
          <AddIcon />
          Add a preview
        </Button>
      </Labeled>
      {isOpen && (
        <PreviewDialog
          open={true}
          onValidated={onValidated}
          close={handleClose}
          {...props}
        />
      )}
    </Fragment>
  );
};

export default AttachPreviewsButton;
